<template>
  <!-- {{ meta.dataset_id }} -->

  <!-- {{ meta.description }} -->
  

  <template v-if="meta.description.includes('mss_standard')">
    <standard-mss-preserved-form-t v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></standard-mss-preserved-form-t>
  </template>
  <template v-else-if="meta.description.includes('live_culture_standard')">
    <standard-live-culture-form-t v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></standard-live-culture-form-t>
  </template>
  <template v-else-if="meta.description.includes('literary_mss')">
    <standard-mss-literary-form-t v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></standard-mss-literary-form-t>
  </template>
  <template v-else-if="meta.description.includes('observation_mss')">
    <standard-mss-observation-form-t v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></standard-mss-observation-form-t>
  </template>
  <template v-else-if="meta.description.includes('species_in_details_mss')">
    <standard-mss-species-in-details-form-t v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></standard-mss-species-in-details-form-t>
  </template>
  <template v-else-if="meta.description.includes('lena_sis_form')">
    <lena-sis-form-t v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></lena-sis-form-t>
  </template>

  <template v-else-if="meta.description.includes('food_composition')">
    <lena-sis-form-t-food v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></lena-sis-form-t-food>
  </template>

  <template v-else-if="meta.description.includes('alltaxonomy')">
    <standard-all-taxonomy-form-t v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></standard-all-taxonomy-form-t>
  </template>

  <template v-else>
    <default-base-form-t v-bind="{mode:'edit', meta:meta, curentRow:curentRow}" v-model="curentRow"></default-base-form-t>
  </template>
<!-- Для видов нельзя исолпьзовать дефолтный - надо почти для каждой таблицы городить шаблон правки-->
</template>
<script>
import { defineComponent } from 'vue';
import DefaultBaseFormT from '@/views/DefaultBaseFormT.vue';
import LenaSisFormT from '@/views/fish/LenaSisFormT.vue';
import StandardMssPreservedFormT from '@/views/StandardMssPreservedFormT.vue';
import StandardLiveCultureFormT from '@/views/StandardLiveCultureFormT.vue';
import StandardMssLiteraryFormT from '@/views/StandardMssLiteraryFormT.vue';
import StandardMssObservationFormT from '@/views/StandardMssObservationFormT.vue';
import StandardMssSpeciesInDetailsFormT from '@/views/StandardMssSpeciesInDetailsFormT.vue';
import StandardAllTaxonomyFormT from '@/views/StandardAllTaxonomyFormT.vue';
import LenaSisFormTFood from '@/views/fish/LenaSisFormTFood.vue';

export default defineComponent({
    name: 'BaseFormT',
    components: {
DefaultBaseFormT,
LenaSisFormT,
StandardMssPreservedFormT,
StandardLiveCultureFormT,
StandardMssObservationFormT,
StandardMssLiteraryFormT,
StandardMssSpeciesInDetailsFormT,
StandardAllTaxonomyFormT,
LenaSisFormTFood,
},

data(){ 
    return {

    }
},
props:['meta', 'curentRow', 'modelValue'],
emits: ['update:modelValue'],
methods: {

},

  mounted(){

  },

})
</script>